import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { jobsRoute} from '../../routes/index';
import { formatNumber, DateFormatter } from '../../utils/date';
import {Link} from 'react-router';
import forEach from 'lodash/forEach';
import { fetchJobs } from '../../actions/jobs';
import connect from '../../utils/connect';
import Spinner from '../../components/svg/spinner';
import translate from '../../utils/translate';


import relLinks from '../../utils/relLinks';


class ContextualJobs extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.state = {
			searchWord: '',
			searchResults: [],
			searched: false,
			active: false,
		};
		this.firstLaunch = true;
	}

	componentWillMount() {
		if (this.props.enableJobs) {
			this.fetchJobs = bindActionCreators(fetchJobs, this.props.dispatch);
			this.fetchJobs();
		}
	}

	componentWillUnmount() {
		document.querySelector('body').classList.remove('context-active');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.enableJobs !== this.props.enableJobs) {
			this.fetchJobs();
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState !== this.state ||
			nextProps !== this.props ||
			nextProps.enableJobs !== this.props.enableJobs
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.active && this.refs.search && this.firstLaunch && this.props.browser.window.width > 1030) {
			this.refs.search.focus();
			this.firstLaunch = false;
		}
	}

	render() {
		let jobs = null;
		let profiles = null;
		let allJobs = null;
		let jobsNum = null;
		let searchWord = null;
		let searchResults = null;
		let total = null;
		let thisJob = null;
		let next = null;
		let prev = null;

		if (this.props.jobs.items && this.props.jobs.items.length) {
			jobs = this.props.jobs.items;
			allJobs = 'All jobs';
			jobsNum = jobs.length;
			searchWord = this.state.searchWord;
			searchResults = [];
			total = jobsNum;
			thisJob = this.props.jobId;
			next = 0;
			prev = 0;

			forEach(jobs, function(job, i) {
				if (job.title.toLowerCase().indexOf(searchWord) > -1 || job.country.toLowerCase().indexOf(searchWord) > -1 || job.city.toLowerCase().indexOf(searchWord) > -1 || job.profiles.name && job.profiles.name.toLowerCase().indexOf(searchWord) > -1) {
					searchResults.push(job);
				}

				if (job.id == thisJob) {
					if (i == jobs.length - 1) {
						next = 0;
					} else {
						next = i + 1;
					}

					if (i == 0) {
						prev = jobs.length - 1;
					} else {
						prev = i - 1;
					}
				}
			});

			next = jobs[next].slug;
			prev = jobs[prev].slug;

			if (searchWord != '') {
				jobsNum = searchResults.length;
				allJobs = 'Found jobs';

				if (!searchResults.length) {
					searchResults.push({
						title: 'No results',
					});
				}
			}
		}

		let url = window.location.href;
		let remove = window.location.href.split('/')[window.location.href.split('/').length -1];

		relLinks(url.replace(remove, prev), url.replace(remove, next));

		let nextClass = 'span2 span4-mobile contextual-menu__next';
		let prevClass = 'span2 span4-mobile contextual-menu__prev';
		let toggleClass = 'span2-plus span6-tablet-plus span6-mobile-plus contextual-menu__toggle';
		let buttonClass = 'contextual-menu__toggle__button';
		let innerClass = 'contextual-menu__inner span14';
		let controlClass = 'contextual-menu__control span14';

		if (this.state.active) {
			nextClass = 'span2-plus span4-mobile contextual-menu__next contextual-menu__next--active';
			prevClass = 'span2 span4-mobile contextual-menu__prev contextual-menu__prev--active';
			toggleClass += ' contextual-menu__toggle--active';
			buttonClass += ' contextual-menu__toggle__button--active';
			innerClass += ' contextual-menu__inner--active';
			controlClass += ' contextual-menu__control--active';
		}

		if (this.props.seen || this.state.active) {
			controlClass += ' contextual-menu__control--seen'
		}

		return (
			<section className='contextual-menu span14'>
				<div className={controlClass}>
					<div className='contextual-menu__control__top'>
						<Link onClick={(event) => this.onLinkClick(event)} to={jobsRoute(prev)}>
						<div className={prevClass}>
							<span className='contextual-menu__arrow contextual-menu__arrow--prev'></span>
						</div>
						</Link>
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						<div className={toggleClass}>
							<button ref='contextualToggle' className={buttonClass} onClick={(event) => this.onClick(event)}>
								<div className='burger-icon'>
									<span><i></i></span>
									<span><i></i></span>
									<span><i></i></span>
								</div>
								<div className='close-icon'>
									<span><i></i></span>
									<span><i></i></span>
								</div>
							</button>
						</div>
						<div className='span4 span2-tablet hide-mobile contextual-menu__filler'></div>
						<Link onClick={(event) => this.onLinkClick(event)} to={jobsRoute(next)}>
						<div className={nextClass}>
							<span className='contextual-menu__arrow contextual-menu__arrow--next'></span>
						</div>
						</Link>
					</div>
					{!this.props.seen && (
					<span className='contextual-menu__control__text'>Discover more</span>
					)}
				</div>
				<div ref='contextualInner' className={innerClass}>
				{this.props.jobs.items && this.props.jobs.items.length && searchResults && this.props.enableJobs && (
					this.renderJobs(searchResults, jobsNum, allJobs, total)
				) || this.props.jobs.items && this.props.jobs.items.length && this.props.enableJobs && (
					this.renderJobs(jobs, jobsNum, allJobs, total)
				) || null}
				</div>
			</section>
		);
	}

	renderJobs(jobs, jobsNum, allJobs, total) {
		let uid = 'contextJobs';
		let rightClass = 'span2-plus contextual-menu__inner-list__right hide-mobile';

		if (this.props.seen || this.state.active) {
			rightClass += ' contextual-menu__inner-list__right--seen';
		}

		return (
			<article key={uid} className='contextual-menu__inner-list span14'>
				<div className='contextual-menu__inner-list__top span14'>
					<h1 className='contextual-menu__inner-list__top__title'>Jobs</h1>
					<span className='contextual-menu__inner-list__top__number'> ({total})</span>
				</div>
				<input ref='search' onChange={(event)=>this.onInput(event)} className='contextual-menu__inner-list__search span12 hide-mobile' type='text' placeholder={translate('contextual/jobsSearch')}/>
				<ul className='contextual-menu__inner-list__items span12-scroll span14-mobile'>
					{jobs.map((job, i) => this.renderJob(job, i))}
				</ul>
				<div className={rightClass}>
					<span className='contextual-menu__inner-list__right__byline'>showing</span>
					<h2 className='contextual-menu__inner-list__right__title'>{allJobs}</h2>
					<span className='contextual-menu__inner-list__right__number'>{jobsNum + ' in total'}</span>
				</div>
			</article>
		);
	}

	renderJob(job, i) {
		let uid = 'contextualJob' + i;
		let date = new DateFormatter(job.createdDate);
		date = date.date + ' ' + date.month + ' ' + date.year;
		let url = jobsRoute(job.slug);

		return (
			<li key={uid} className='contextual-menu__inner-list__items__item span4 span6-tablet span14-mobile'>
				<h2 className='contextual-menu__inner-list__items__item__title'>{job.title}</h2>
				{job.profiles && job.profiles.name && (
				<span className='contextual-menu__inner-list__items__item__profile'>{job.profiles.name}</span>
				)}
				{job.city && (
				<span className='contextual-menu__inner-list__items__item__location'>{job.city + ', ' + job.country}</span>
				)}
				{job.createdDate && (
				<span className='contextual-menu__inner-list__items__item__date'>{date}</span>
				)}
				{job.slug && this.props.browser.window.width > 719 && (
				<div className='contextual-menu__inner-list__items__item__overlay'><Link onClick={(event) => this.onLinkClick(event)} to={url} className='button contextual-menu__inner-list__items__item__button'>Read more</Link></div>
				) || job.slug && (
				<Link onClick={(event) => this.onLinkClick(event)} to={url} className='contextual-menu__inner-list__items__item__button--fill'></Link>
				)}
			</li>
		);
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	onInput(e) {
		this.setState({
			...this.state,
			searchWord: e.target.value,
		});
	}

	onLinkClick(e) {
		document.querySelector('body').classList.remove('context-active');

		this.setState({
			active: false,
		});
	}

	onClick(e) {
		e.preventDefault();
		document.querySelector('body').classList.toggle('context-active');

		try {
			localStorage.setItem('context', 'seen');
		} catch (e) {}

		this.setState({
			active: !this.state.active,
		});
	}
}

export default connect(ContextualJobs);



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextualJobs.js
 **/